export const TAG_PILL_COLORS: Record<string, string> = {
  admin: '#bef26480',
  accounting: '#34d39980',
  sales: '#fbbf2480',
  marketing: '#f472b680',
  engineers: '#5A708D80',
  installation: '#F4AC6A80',
  logistics: '#2dd4bf80',
  corporate: '#94a3b880',
  r_d: '#86efac80',
  support: '#7dd3fc80',
  customer_service: '#6366f180',
  it: '#e879f980',
  operations: '#d6d3d180',
  finances: '#05966980',
  manufacturing: '#22d3ee80',
  hr: '#a78bfa80',
  nuwa: '#f59e0b80',
  to_do_r: '#ec489980',
  carryoutsupplies: '#14b8a680',
  legal: '#8b5cf680',
  procurement: '#7c3aed80',
  software: '#38bdf880',
  hardware: '#f9731680',
  ried: '#a855f780',
  elevator: '#65a30d80',
};

export const ROLE_LABELS: Record<string, string> = {
  admin: 'TFRI',
  accounting: 'Accounting',
  sales: 'Sales',
  marketing: 'Marketing',
  engineers: 'Engineers',
  installation: 'Installation',
  logistics: 'Logistics',
  corporate: 'Corporate',
  r_d: 'R&D',
  support: 'Support',
  customer_service: 'Customer Service',
  it: 'IT',
  operations: 'Operations',
  finances: 'Finances',
  manufacturing: 'Manufacturing',
  hr: 'HR',
  nuwa: 'NUWA',
  to_do_r: 'To-Do R',
  carryoutsupplies: 'Carryout Supplies',
  legal: 'Legal',
  procurement: 'Procurement',
  software: 'Software',
  hardware: 'Hardware',
  ried: 'Ried',
  elevator: 'Elevator',
};
